/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { space } from 'styles/variables';

export const SameHours = styled.div`
  align-items: center;
  display: flex;
  margin-top: ${space.x3};
`;
